export type DestinationMode = 'pick_existing' | 'connect_another' | null;

export interface OnboardingSessionState {
    active: boolean;
    step: number;
    sourceCalendarUuid: string | null;
    destinationMode: DestinationMode;
}

const STORAGE_KEY = 'calensync_onboarding';

export function readOnboardingState(): OnboardingSessionState | null {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        return JSON.parse(raw) as OnboardingSessionState;
    } catch {
        return null;
    }
}

export function writeOnboardingState(state: OnboardingSessionState): void {
    if (typeof window === 'undefined') {
        return;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
}

export function clearOnboardingState(): void {
    if (typeof window === 'undefined') {
        return;
    }
    sessionStorage.removeItem(STORAGE_KEY);
}

function getOnboardingDismissedKey(userUuid: string): string {
    return `calensync_onboarding_dismissed_${userUuid}`;
}

export function isOnboardingDismissed(userUuid: string): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    return localStorage.getItem(getOnboardingDismissedKey(userUuid)) === '1';
}

export function setOnboardingDismissed(userUuid: string): void {
    if (typeof window === 'undefined') {
        return;
    }
    localStorage.setItem(getOnboardingDismissedKey(userUuid), '1');
}

export function resolveResumeStep(
    accountsLength: number,
    saved: OnboardingSessionState | null,
): number {
    if (saved?.active && saved.step != null) {
        if (saved.step === 0 && accountsLength >= 1) {
            return 1;
        }
        return saved.step;
    }
    if (accountsLength === 0) {
        return 0;
    }
    if (saved?.sourceCalendarUuid) {
        return 2;
    }
    return 1;
}
